import { getAppConfig } from '@services/config';

export enum PlanTypeId {
    DEFAULT = 'default',
    PREMIUM = 'plan_premium',
    PREMIUM_SELECTION = 'plan_premium_selection',
    PREMIUM_PRO = 'plan_pro_premium',
    PREMIUM_RENEWAL = 'plan_premium_renew',
    RENEWAL = 'plan_renew',
    PREMIUM_ENTRY = 'plan_premium_entry',
    PREMIUM_MULTILIGNE = 'plan_premium_multiligne',
    SIMO = 'plan_simo',
    SIMO_SELECTION = 'plan_simo_selection',
    SIMO_ENTRY = 'plan_simo_entry',
    SIMO_MULTILIGNE = 'plan_simo_multiligne',
    SIMO_PRO = 'plan_pro_simo',
    SOWO = 'plan_sowo',
    SOWO_PRO = 'plan_pro_sowo',
    SOWO_RENEWAL = 'plan_sowo_renew',
    SOWO_SPECIALS = 'plan_sowo_specials',
    IDEO = 'plan_ideo',
    IDEO_PRO = 'plan_ideo_pro',
    FAIM = 'faim',
    FAIM_PREMIUM = 'faim_premium',
    PREMIUM_PRO_SELECTION = 'plan_pro_premium_selection',
    SIMO_PRO_SELECTION = 'plan_pro_simo_selection',
    FAI = 'fai',
    FAIM_UNLIMITED = 'faim_unlimited',
    FAI_26 = 'fai-26',
    FAI_ELIGIBILITE = 'fai-eligibilite',
    FAI_ESSENTIEL = 'fai-essentiel',
    FAI_PRO = 'fai-pro',
    FAI_SERVICE = 'fai_service',
    OFFRES_AUTRES = 'offres_autres',
    FAI_BANQUE_WEB = 'FAI-BANQUE-WEB',
    FAI_SIMO = 'FAI-SIMO',
    FAI_SIMO_ELIGIBILITE = 'fai-simo-eligibilite',
    BELOW_THE_LINE_WEB = 'below_the_line_web',
    FAI_TABLET = 'fai-tablette',
    FAMILY_WEB = 'family-web',
    FAI_CONVERGENCE = 'fai-convergence',
    FAI_PREMIUM = 'fai-premium',
    FAI_SMART_TV = 'fai-smart-tv',
    FAI_VIDEOPROJECTOR = 'fai-videoprojecteur',
    FAI_SMART_MONITOR = 'fai-smart-monitor',
    FAI_GAMING = 'fai-gaming',
    FAI_BYOU = 'fai-byou',
    SS_PREMIUM = 'FAI-SS-PREMIUM',
    FAI_PUREBYOU = 'fai-purebyou',
    FAI_5GBOX = 'fai-5gbox',
    FAI_EXTRA_BOX = 'fai-extrabox-web',
    FAI_PROMO_PRIVEE = 'fai-promo-privee',
    FAI_BOX_INTERNET = 'fai-box-internet',
    FAI_BIG = 'fai-big',
    FAI_ONGLET_FIN_DE_SERIE = 'fai-onglet-fin-de-serie',
    FAI_ONGLET_BYOU = 'fai-onglet-byou',
    FAI_ONGLET_BBOX = 'fai-onglet-bbox',
    FAI_ONGLET_XGBOX = 'fai-onglet-xgbox',
    FAI_HOME = 'fai-home',
    FAI_LM = 'fai-licence-de-marque',
}

export const faiTabsCategories = [
    PlanTypeId.FAI_ONGLET_BYOU,
    PlanTypeId.FAI_ONGLET_XGBOX,
    PlanTypeId.FAI_ONGLET_BBOX,
    PlanTypeId.FAI_ONGLET_FIN_DE_SERIE,
];

export enum PlanSubTypeId {
    CLASSIC = 'classique',
    SMART_CHANGE = 'swappy',
    PARTNER = 'bundle_partner',
}

export enum MarketingType {
    MULTILINE = 'MULTILIGNES',
    PORTABILITY = 'PORTABILITE',
    ZIP_CODE_FIXED_ELIGIBILITY = 'CODE_POSTAL_ELIGIBILITE_FIXE',
    SALES = 'SOLDES',
    HOME = 'FOYER',
    MOBILE = 'MOBILE',
    TRADE_IN_BONUS = 'BONUS_REPRISE',
}

export enum PlanRange {
    DEFAULT = '',
    WITH_MOBILE = 'forfait_avec_mobile',
    WITHOUT_MOBILE = 'forfait_sans_mobile',
    B_YOU = 'b_you',
}

export const OPTION_LOCKED_ID = '12782';

const config = getAppConfig();
const { urlKey, planGencode, optionGencode } = config.defaultPlans.kidsWatch;

export const KidsWatch = {
    URL_KEY: urlKey,
    PLAN_GENCODE: planGencode,
    OPTION_GENCODE: optionGencode,
};
